var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-menu",
    {
      attrs: {
        bottom: "",
        left: "",
        "nudge-bottom": "45",
        "nudge-left": "20",
        "content-class": "navigation-context-menu",
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "div",
                _vm._g(
                  _vm._b({ staticClass: "avatar" }, "div", attrs, false),
                  on
                ),
                [
                  _c("img", {
                    staticClass: "avatar-svg",
                    attrs: {
                      src: require("@/assets/images/svg/Avatar_Action.svg"),
                      alt: "Avatar icon",
                    },
                  }),
                  _c("span", { staticClass: "avatar-name" }, [
                    _vm._v(_vm._s(_setup.userName.toLowerCase())),
                  ]),
                ]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "v-list",
        { staticClass: "list" },
        [
          _c("v-list-item", { staticClass: "list-title" }, [
            _c("div", { staticClass: "user-info-container" }, [
              _c("span", { staticClass: "avatar-name" }, [
                _vm._v(_vm._s(_setup.userName.toLowerCase())),
              ]),
              _c(
                "span",
                {
                  staticClass: "company-name",
                  attrs: { title: _setup.companyName },
                },
                [_vm._v(_vm._s(_setup.companyName))]
              ),
            ]),
          ]),
          !_setup.isPortalUser
            ? _c("v-list-item", { staticClass: "list-item" }, [
                _c(
                  "span",
                  {
                    staticClass: "sub-menu-activator",
                    on: {
                      click: function ($event) {
                        return _setup.redirect()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_setup.text.account) + " ")]
                ),
              ])
            : _vm._e(),
          _c(
            "v-list-item",
            {
              staticClass: "list-item",
              on: { click: _setup.showCloseSessionDialog },
            },
            [
              _c("span", { class: _setup.icon.close }),
              _c("span", [_vm._v(_vm._s(_setup.text.closeSession))]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }